import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";
import { IInquiry } from "src/@types/inquiries";
import { IUserProfileCard, IUser } from "src/@types/users";
import { USERS_SLICE_NAME } from "./actions";
import {
  getUserProfileCardSidebarReducer,
  getUserProfileInfoReducer,
  getUserProfileClonesReducer,
  getUserProfileInquiriesReducer,
} from "./reducers";

interface IUsersObject<T> {
  isLoading: boolean;
  data: T;
}

export interface UsersState {
  userProfileCard: IUsersObject<IUserProfileCard>;
  userProfileInfo: IUsersObject<IUser>;
  clones: IUsersObject<IResponseWithPagination<IClone>>;
  inquiries: IUsersObject<IResponseWithPagination<IInquiry>>;
}

const initialState: UsersState = {
  userProfileCard: {
    isLoading: false,
    data: null,
  },
  userProfileInfo: {
    isLoading: false,
    data: null,
  },
  clones: {
    isLoading: false,
    data: null,
  },
  inquiries: {
    isLoading: false,
    data: null,
  },
};

export const { reducer: users } = createSlice({
  name: USERS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getUserProfileCardSidebarReducer(builder);
    getUserProfileInfoReducer(builder);
    getUserProfileClonesReducer(builder);
    getUserProfileInquiriesReducer(builder);
  },
});
